module.exports = __webpack_public_path__ + "media/campaingNew_video.1a8ec23e.mp4";